module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_stretchlab-f5bba60d2ef799f2e063e0d308a95dbd.png";